export default __webpack_public_path__ + "static/media/kits.04af995e.png";